import { Component, OnInit } from '@angular/core';
import { of, switchMap } from 'rxjs';
import { PreferenceModel } from 'src/app/core/models/preference/preference-model';
import { ThemeModel } from 'src/app/core/models/preference/theme-model';
import { PreferenceService, PreferenceType } from 'src/app/core/services/preference.service';
import { EventService } from '../../core/services/event.service';

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.scss']
})
export class VerticalComponent implements OnInit {

  isCondensed = false;
  pref?: PreferenceModel;
  
  constructor(
    private eventService: EventService,
    private userPreferenceService: PreferenceService) { }

  ngOnInit(): void {

    document.documentElement.setAttribute('data-layout', 'vertical');
    document.documentElement.setAttribute('data-preloader', 'disable');
    this.userPreferenceService.currentPreference
      .subscribe((data: PreferenceType) => {
        if (data) {
          let theme = data.theme;
          document.documentElement.setAttribute('data-topbar', theme.topbar);
          document.documentElement.setAttribute('data-sidebar', theme.sidebar);
          document.documentElement.setAttribute('data-sidebar-size', theme.size);
          document.documentElement.setAttribute('data-layout-style', theme.sidebarView);
          document.documentElement.setAttribute('data-layout-mode', theme.mode);
          document.documentElement.setAttribute('data-layout-width', theme.width);
          document.documentElement.setAttribute('data-layout-position', theme.position);
          document.documentElement.setAttribute('data-layout-position', theme.position);
          document.documentElement.setAttribute('data-sidebar-image', theme.sidebarImage);          

          this.pref = data;
        }
      });

    window.addEventListener('resize' , function(){
      if (document.documentElement.clientWidth <= 767) {
        document.documentElement.setAttribute('data-sidebar-size', '');
      }
      else if (document.documentElement.clientWidth <= 1024) {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      else if (document.documentElement.clientWidth >= 1024) {      
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
    })
  }

  /**
   * On mobile toggle button clicked
   */
   onToggleMobileMenu() {
    document.body.classList.toggle('sidebar-enable');    
    const currentSIdebarSize = document.documentElement.getAttribute("data-sidebar-size");
    if (document.documentElement.clientWidth >= 992) {
      if (currentSIdebarSize == null) {
        (document.documentElement.getAttribute('data-sidebar-size') == null || document.documentElement.getAttribute('data-sidebar-size') == "lg") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg')
      } else if (currentSIdebarSize == "md") {
        (document.documentElement.getAttribute('data-sidebar-size') == "md") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'md')
      } else {
        (document.documentElement.getAttribute('data-sidebar-size') == "sm") ? document.documentElement.setAttribute('data-sidebar-size', 'lg') : document.documentElement.setAttribute('data-sidebar-size', 'sm')
      }
    }
    this.isCondensed = !this.isCondensed;
  }

  /**
   * on settings button clicked from topbar
   */
   onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    const rightBar = document.getElementById('theme-settings-offcanvas');
    if(rightBar != null){
      rightBar.classList.toggle('show');
      rightBar.setAttribute('style',"visibility: visible;");

    }
  }

  onResize(event:any) {
    if(document.body.getAttribute('layout') == "twocolumn") {
      if (event.target.innerWidth <= 767) {
        this.eventService.broadcast('changeLayout', 'vertical');     
      }else{
        this.eventService.broadcast('changeLayout', 'twocolumn');  
        document.body.classList.remove('twocolumn-panel'); 
        document.body.classList.remove('vertical-sidebar-enable'); 
      }
    }
  }

}
